import React from "react";
import { Route } from "react-router";
import AdminHome from "../components/admin/index";
import ScriptTemplatesIndex from "../components/admin/script_templates/index";
import ScriptTemplatesShow from "../components/admin/script_templates/show";
import NewScriptTemplate from "../components/admin/script_templates/new";
import EditScriptTemplate from "../components/admin/script_templates/edit";
import UsersIndex from "../components/admin/users/index";
import NewUser from "../components/admin/users/new";
import UsersEdit from "../components/admin/users/edit";
import type { IUser } from "../types/iuser";
import ContactsIndex from "../components/admin/contacts/index";
import NewContact from "../components/admin/contacts/new";
import EditContact from "../components/admin/contacts/edit";

interface AdminRoutesProps {
  currentUser: IUser;
}

const adminRoutes = (props: AdminRoutesProps) => [
  <Route key="/admin" path="/admin" element={<AdminHome {...props} />} />,
  <Route
    key="/admin/script_templates"
    path="/admin/script_templates"
    element={<ScriptTemplatesIndex {...props} />}
  />,
  <Route
    key="/admin/script_templates/:scriptTemplateId/edit"
    path="/admin/script_templates/:scriptTemplateId/edit"
    element={<EditScriptTemplate {...props} />}
  />,
  <Route
    key="/admin/script_templates/:scriptTemplateId"
    path="/admin/script_templates/:scriptTemplateId"
    element={<ScriptTemplatesShow {...props} />}
  />,
  <Route
    key="/admin/script_templates/new"
    path="/admin/script_templates/new"
    element={<NewScriptTemplate {...props} />}
  />,
  <Route
    key="/admin/users"
    path="/admin/users"
    element={<UsersIndex {...props} />}
  />,
  <Route
    key="/admin/users/new"
    path="/admin/users/new"
    element={<NewUser {...props} />}
  />,
  <Route
    key="/admin/users/:userId/edit"
    path="/admin/users/:userId/edit"
    element={<UsersEdit {...props} />}
  />,
  <Route
    key="/admin/contacts"
    path="/admin/contacts"
    element={<ContactsIndex {...props} />}
  />,
  <Route
    key="/admin/contacts/new"
    path="/admin/contacts/new"
    element={<NewContact {...props} />}
  />,
  <Route
    key="/admin/contacts/:contactId/edit"
    path="/admin/contacts/:contactId/edit"
    element={<EditContact {...props} />}
  />
];

export default adminRoutes;
